import { render, staticRenderFns } from "./CoozzyPlusCircleIcon.vue?vue&type=template&id=4758b6d5&scoped=true"
import script from "./CoozzyPlusCircleIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyPlusCircleIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyPlusCircleIcon.vue?vue&type=style&index=0&id=4758b6d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4758b6d5",
  null
  
)

export default component.exports